export var DataPrefix = ':';
export var IndexPrefix = '@';
export var ScalePrefix = '%';
export var SignalPrefix = '$';